import React from "react";
import { Link } from "react-router-dom";
import "./Galleria.css";
import "./Curriculum.css";

// Ogni anno è una colonna; gli eventi possono contenere corsivi.
const anni = [
  {
    anno: "2020",
    eventi: [
      <>
        <i>Cuerpos Narrativo</i>, mostra collettiva, Centro Cìvico Zaidìn /
        Granada
      </>,
    ],
  },
  {
    anno: "2022",
    eventi: [
      <>
        <i>Rinascere</i>, mostra collettiva, Pinacoteca comunale / Positano
      </>,
      <>Live painting performance, Lago Diana / Caserta</>,
      <>Emanuela Auricchio, mostra personale, Covo 17 / Aversa</>,
      <>
        <i>STRIATURE</i>, mostra personale, Salumeria Upnea / Napoli
      </>,
      <>
        Video proiezione collettiva, concorso Artisti Contemporanei, Carrousel
        du Louvre / Parigi
      </>,
      <>
        HUB-ERGO, mostra e workshop del progetto Cassandra Parla, Real Albergo
        dei Poveri / Napoli
      </>,
    ],
  },
  {
    anno: "2023",
    eventi: [
      <>
        <i>L'Otto e 3/4</i>, mostra collettiva, spazio comunale Piazza Forcella
        - biblioteca Annalisa Durante / Napoli
      </>,
      <>Live painting performance, Reggia di Caserta Outlet / Caserta</>,
      <>
        <i>Intersezioni d'anime</i>, mostra collettiva, SpazioTRA / Napoli
      </>,
      <>
        Laboratorio e workshop in collaborazione con LESS Onlus e M.I.Q., Via
        Fiumicello a Loreto / Napoli
      </>,
      <>
        <i>5 Fragments</i> Arte Giovane, mostra collettiva, galleria
        FrameArsArtes / Napoli
      </>,
      <>
        Laboratorio e workshop in collaborazione con LESS Onlus, spazio comunale
        di Procida / Procida
      </>,
      <>Partecipazione al LIMEN Festival / Salerno</>,
      <>Live painting performance, Festival SPAZIALE / Agropoli</>,
      <>
        Mostra collettiva di street art del progetto Cassandra Parla in
        collaborazione con Open House Napoli / Napoli
      </>,
      <>
        Inaugurazione <i>Tras' Lab</i>, di cui è co-fondatrice, mostra
        collettiva / Napoli
      </>,
    ],
  },
  {
    anno: "2024",
    eventi: [
      <>
        Laboratorio e workshop del progetto Cassandra Parla, Magazzini sul Po' /
        Torino
      </>,
      <>
        Live painting performance e mostra personale, Piazzale Cairoli di
        Castellarano / Reggio Emilia
      </>,
      <>Live painting performance, Teatro Toniolo / Mestre</>,
    ],
  },
];

const Curriculum = () => {
  return (
    <div className="galleria">
      {anni.map((a) => (
        <div className="anno" key={a.anno}>
          <h1 className="anno-titolo">{a.anno}</h1>
          <div className="anno-eventi">
            <ul>
              {a.eventi.map((e, i) => (
                <li key={i}>{e}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}

      <Link to="/Home" className="torna">
        Torna alla home
      </Link>
    </div>
  );
};

export default Curriculum;
